<template>
    <div class="row">
        <template v-if="configuration.dashboard_products">
            <div class="col-xl-6 col-md-6">
                <section class="card card-dashboard">
                    <div class="card-body" v-if="loaders.items_by_sales">
                        <template>
                            <loader-graph :rows="4" :columns="1" :radius="100" :hideCircle="true"></loader-graph>
                        </template>
                    </div>
                    <div class="card-body pb-0" v-show="!loaders.items_by_sales">
                        <div class="row">
                            <div class="col-12 text-right">
                                <el-button type="danger" size="mini" @click.prevent="exportSalesByItem('pdf')">
                                    <i class="fa fa-file-pdf"></i> Exportar PDF
                                </el-button>
                                <el-button type="success" size="mini" @click.prevent="exportSalesByItem('xlsx')">
                                    <i class="fa fa-file-excel"></i> Exportar Excel
                                </el-button>
                            </div>
                            <div class="col-12">
                                <label>Top Ventas por producto</label>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="Aplica filtro por establecimiento y período"
                                    placement="top-start"
                                >
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </div>
                            <div class="col-6">
                                <div class="mt-3 mb-1">
                                    <el-checkbox  v-model="localForm.enabled_move_item" @change="loadDataAditional">Ordenar por movimientos</el-checkbox><br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0" v-show="!loaders.items_by_sales">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th class="text-right">
                                            Mov.
                                            <el-tooltip class="item" effect="dark" content="Movimientos (Cantidad de veces vendido)" placement="top-start"><i class="fa fa-info-circle"></i></el-tooltip>
                                        </th>
                                        <th class="text-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in items_by_sales"
                                        :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ row.internal_id }}</td>
                                        <td>{{ row.description }}</td>
                                        <td class="text-right">{{ row.move_quantity }}</td>
                                        <td class="text-right">{{ row.total }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-body">
                        <el-button type="primary"
                            size="small"
                            @click.prevent="clickViewAll()"
                        >
                            Ver todo
                        </el-button>
                        <!-- <a class="btn btn-primary btn-sm" href="dashboard/sales-by-product">Ver todo</a> -->
                    </div>
                </section>
            </div>
        </template>
        <template v-if="configuration.dashboard_clients">
            <div class="col-xl-6 col-md-6">
                <section class="card card-dashboard">
                    <div class="card-body" v-if="loaders.top_customers">
                        <template>
                            <loader-graph :rows="4" :columns="1" :radius="100" :hideCircle="true"></loader-graph>
                        </template>
                    </div>
                    <div class="card-body pb-0" v-show="!loaders.top_customers">
                        <div class="row">
                            <div class="col-12 text-right">
                                <el-button type="danger" size="mini" @click="exportTopCustomers('pdf')">
                                    <i class="fa fa-file-pdf"></i> Exportar PDF
                                </el-button>
                                <el-button type="success" size="mini" @click="exportTopCustomers('xlsx')">
                                    <i class="fa fa-file-excel"></i> Exportar Excel
                                </el-button>
                            </div>

                            <div class="col-12">
                                <label>Top clientes</label>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="Aplica filtro por establecimiento y período"
                                    placement="top-start"
                                >
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </div>
                            <div class="col-6">
                                <div class="mt-3">
                                    <el-checkbox  v-model="localForm.enabled_transaction_customer" @change="loadDataAditional">Ordenar por transacciones</el-checkbox><br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0" v-show="!loaders.top_customers">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Cliente</th>
                                        <th class="text-right">
                                            Trans.
                                            <el-tooltip
                                                class="item"
                                                effect="dark"
                                                content="Transacciones (Cantidad de ventas realizadas)"
                                                placement="top-start"
                                            >
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                        </th>
                                        <th class="text-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in top_customers"
                                        :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ row.name }}<br /><small v-text="row.number"></small></td>
                                        <td class="text-right">{{ row.transaction_quantity }}</td>
                                        <td class="text-right">{{ row.total }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </div>
        </template>
        <template v-if="configuration.dashboard_products">
            <div class="col-xl-6 col-md-12 col-lg-12">
                <dashboard-stock :establishment="localForm.establishment_id"></dashboard-stock>
            </div>
        </template>
        <template v-if="configuration.dashboard_products">
            <div class="col-xl-6 col-md-12 col-lg-12">
                <dashboard-inventory :establishment="localForm.establishment_id"></dashboard-inventory>
            </div>
        </template>
    </div>
</template>

<script>
    import moment from 'moment'
    import DashboardStock from '../views/partials/dashboard_stock.vue'
    import DashboardInventory from '../views/partials/dashboard_inventory.vue'
    import LoaderGraph from './loaders/l-graph.vue'

    export default {
        name: 'DashboardReportsStrategics',
        components: {DashboardStock, DashboardInventory, LoaderGraph},
        props: ['configuration', 'form'],
        data() {
            return {
                resource: "dashboard",
                items_by_sales: [],
                top_customers: [],
                loaders: {},
                // form: {},
                localForm: { ...this.form }
            }
        },
        watch: {
            form: {
                async handler (newForm) {
                    this.localForm = { ...newForm }
                    await this.loadDataAditional()
                },
                deep: true
            }
        },
        created() {
            this.initLoaders()
        },
        async mounted() {
            await this.loadDataAditional()
        },
        methods: {
            initLoaders() {
                this.loaders = {
                    items_by_sales: true,
                    top_customers: true,
                };
            },
            async exportSalesByItem(type) {
                /**
                * Método tradicional
                */
                // const query = new URLSearchParams(this.form).toString()
                // const url = `${this.resource}/exports/sales-by-item/${type}?${query}`
                // window.open(url, '_blank')

                /**
                * Método con colas
                */
                const params = {
                    ...this.form,
                    type: type
                }
                try {
                    
                    const response = await this.$http.post(`${this.resource}/exports/sales-by-item`, params)
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                } catch (error) {
                    this.$message.error(error.message)
                }
            },
            loadDataAditional() {
                this.showLoadersLoadDataAditional();

                this.$http
                    .post(`/${this.resource}/data_aditional`, this.localForm)
                    .then((response) => {
                        // no es necesario el purchase, dado que no modifica nada los loadDataAditional
                        // this.purchase = response.data.data.purchase;
                        this.items_by_sales = response.data.data.items_by_sales;
                        this.top_customers = response.data.data.top_customers;
                        this.hideLoadersLoadDataAditional();
                    });
            },
            showLoadersLoadDataAditional() {
                this.loaders.purchase = true;
                this.loaders.items_by_sales = true;
                this.loaders.top_customers = true;
            },
            hideLoadersLoadDataAditional() {
                this.loaders.purchase = false;
                this.loaders.items_by_sales = false;
                this.loaders.top_customers = false;
            },
            async exportTopCustomers(type) {
                // const query = new URLSearchParams(this.form).toString()
                // const url = `${this.resource}/exports/top-customers/${type}?${query}`
                // window.open(url, '_blank')

                /**
                * Método con colas
                */
                const params = {
                    ...this.form,
                    type: type
                }
                try {
                    
                    const response = await this.$http.post(`${this.resource}/exports/top-customers`, params)
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                } catch (error) {
                    this.$message.error(error.message)
                }
            },
            clickViewAll() {
                window.location.href = '/dashboard/sales-by-product'
            }
        },
    }
</script>


// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/components/ReportsStrategics.vue